export enum PartnerCommitmentTranslations {
  ExportPlan = 'partnercommitment-export-plan',
  ExportMetricSaveError = 'partnercommitment-export-metric-save-error',
  Export = 'partnercommitment-export',
  ExportNetNdp = 'partnercommitment-export-net-ndp',
  ExportPDF = 'partnercommitment-export-pdf',
  ExportPDFV2 = 'partnercommitment-export-pdf-v2',
  ExportPPTX = 'partnercommitment-export-pptx',
  ExportJSON = 'partnercommitment-export-json',
  DownloadPartnerPlan = 'partnercommitment-download-partner-plan',
  GoTo = 'partnercommitment-go-to',
  ReviewPlan = 'partnercommitment-review-plan',
  Review = 'partnercommitment-review',
  BlockedActions = 'partnercommitment-blocked-actions',
}

export enum PartnerCompletenessTranslations {
  WidgetTitle = 'jbp-completeness-title',
  TotalCompleteness = 'jbp-completeness-total',
  GoToAcknowledgement = 'jbp-commitment',

  Assortment = 'jbp-completeness-assortment-info',
  BasicInfo = 'jbp-completeness-basic-info',
  ContactInfo = 'jbp-completeness-contact-info',
  SwotAnalysis = 'jbp-completeness-swot-analysis',
  DeviceInfoPrint = 'jbp-completeness-device-info-print',
  DeviceInfo = 'jbp-completeness-device-info',
  ShareOfBusiness = 'jbp-completeness-share-of-business',
  MarketInfo = 'jbp-completeness-market-info',
  SolutionsInfo = 'jbp-completeness-solutions-info',
  FinSobPlan = 'jbp-completeness-fin-sob-plan',
  Poly = 'jbp-completeness-poly',
  Planning = 'jbp-completeness-planning',
  InitiativesPlan = 'jbp-completeness-initiatives-plan',
  ActionsPlan = 'jbp-completeness-actions-plan',
  MasterDealer = 'jbp-completeness-master-dealer',
  InventoryManagement = 'jbp-completeness-inventory-management',
  CreditStatusInfo = 'jbp-completeness-credit-status-info',
  MIF = 'jbp-completeness-mif',
  MPSSubs = 'jbp-completeness-mps-subs',
  Rooms = 'jbp-completeness-rooms',
  AIPC = 'jbp-completeness-aipc',
  MPSStatusInfo = 'jbp-completeness-mps-status-info',
  PrintServicesStatusInfo = 'jbp-completeness-print-services-status-info',
  PersonalSystemsServicesStatusInfo = 'jbp-completeness-ps-services-status-info',
}

export enum PlanGradeTranslations {
  congratulations = 'jbp-commitment-plan-grade-congratulations',
  title = 'jbp-commitment-plan-grade-title',
  howImprove = 'jbp-commitment-plan-grade-how-improve',
  later = 'jbp-commitment-plan-grade-later',
  outOf = 'jbp-commitment-plan-grade-out-of',
  pts = 'jbp-commitment-plan-grade-pts',
  popupTitle = 'jbp-commitment-plan-grade-popup-title',
  popupGreetings = 'jbp-commitment-plan-grade-popup-greetings',
  ActionDetailPoint = 'jbp-commitment-plan-grade-action-detail-point',
  ActionDetailPoints = 'jbp-commitment-plan-grade-action-detail-points',
  ActionDetailClose = 'jbp-commitment-plan-grade-action-detail-close',
}
